var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "511432BE-7D2C-429E-88DA-A412E1DEC67A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-update-stock",
    transform: "translate(-1244, -478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1200, 358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "move-icon-copy",
    transform: "translate(44, 120)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    transform: "translate(12, 12) rotate(90) translate(-12, -12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(12, 12) rotate(90) translate(-12, -12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25002,16.63462 C4.03752,16.63462 3.8594,16.56262 3.71565,16.41882 C3.5719,16.27502 3.50002,16.09682 3.50002,15.88422 C3.50002,15.67162 3.5719,15.49352 3.71565,15.35002 C3.8594,15.20642 4.03752,15.13462 4.25002,15.13462 L19.75002,15.13462 C19.96252,15.13462 20.14062,15.20652 20.28432,15.35032 C20.42812,15.49412 20.50002,15.67232 20.50002,15.88492 C20.50002,16.09752 20.42812,16.27562 20.28432,16.41922 C20.14062,16.56282 19.96252,16.63462 19.75002,16.63462 L4.25002,16.63462 Z M4.25002,12.74992 C4.03752,12.74992 3.8594,12.67802 3.71565,12.53422 C3.5719,12.39042 3.50002,12.21222 3.50002,11.99962 C3.50002,11.78702 3.5719,11.60892 3.71565,11.46542 C3.8594,11.32182 4.03752,11.25002 4.25002,11.25002 L19.75002,11.25002 C19.96252,11.25002 20.14062,11.32192 20.28432,11.46572 C20.42812,11.60952 20.50002,11.78772 20.50002,12.00032 C20.50002,12.21292 20.42812,12.39102 20.28432,12.53462 C20.14062,12.67812 19.96252,12.74992 19.75002,12.74992 L4.25002,12.74992 Z M4.25002,8.86535 C4.03752,8.86535 3.8594,8.79344 3.71565,8.64963 C3.5719,8.50583 3.50002,8.32763 3.50002,8.11503 C3.50002,7.90244 3.5719,7.72436 3.71565,7.58078 C3.8594,7.43718 4.03752,7.36538 4.25002,7.36538 L19.75002,7.36538 C19.96252,7.36538 20.14062,7.43728 20.28432,7.5811 C20.42812,7.72492 20.50002,7.90312 20.50002,8.1157 C20.50002,8.3283 20.42812,8.50639 20.28432,8.64998 C20.14062,8.79356 19.96252,8.86535 19.75002,8.86535 L4.25002,8.86535 Z",
    id: "Shape",
    fill: "#696D77",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    transform: "translate(12, 12) rotate(90) translate(-12, -12)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.036362db0ea31b93eb5fd149ba23e298.svg";
export { ForwardRef as ReactComponent };